import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { User } from '@app/shared/models/user.model';
import { TutorialComponent } from '../tutorial/tutorial.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [MatSidenavModule, CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit {
  screenSize!: string;
  showLogoutButton: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    const isMobile: boolean = window.innerWidth < 768;

    this.screenSize = isMobile ? 'mobile' : 'desktop';

    this.showLogoutButton = !!this.authService.user.value;

    this.authService.user$.subscribe((user: User | null) => {
      this.showLogoutButton = !!user;
    });
  }

  onLogout() {
    this.authService.logout();
  }

  onTerms() {
    // this.router.navigate(['/terms-and-conditions']);

    window.open('https://zippmat.com/terms.html', '_blank');
  }

  onTutorial() {
    this.dialog.open(TutorialComponent, {
      maxWidth: '1000px',
      maxHeight: '600px',
    });
  }

  onPrivacyPolicy() {
    window.open('https://zippmat.com/privacy-policy.html', '_blank');
  }

  onLogoutKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.onLogout();
    }
  }
}
